import DefaultFullWhiteLogo from "@assets/branding/default/physiome-monochrome.svg";
import DefaultDefaultLogo from "@assets/branding/default/physiome.svg";
import BrFullWhiteLogo from "@assets/branding/pt-br/physiome-monochrome.svg";
import BrDefaultLogo from "@assets/branding/pt-br/physiome.svg";
import { localeManager } from "@core/service-container";
import { SVGComponent } from "@typings/svg-component";
import { useObservable } from "micro-observables";
import React, { SVGProps } from "react";

type LogoType = "monochrome" | "default";

const allLogos: Record<string, Record<LogoType, SVGComponent>> = {
	"pt-BR": { default: BrDefaultLogo, monochrome: BrFullWhiteLogo },
	default: { default: DefaultDefaultLogo, monochrome: DefaultFullWhiteLogo },
};

interface Props extends SVGProps<SVGElement> {
	type?: LogoType;
}

export const AppLogo = ({ type = "default", ...otherProps }: Props): JSX.Element => {
	const locale = useObservable(localeManager.locale);
	const Icon = allLogos[locale in allLogos ? locale : "default"][type];
	return <Icon {...otherProps} />;
};
